var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-resources-card" }, [
    _vm.result.image
      ? _c("div", {
          staticClass: "c-resources-card__img",
          style: { backgroundImage: "url(" + _vm.result.image.url + ")" }
        })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "c-resources-card__content" }, [
      _vm.result.type
        ? _c("span", { staticClass: "c-resources-card__ribbon" }, [
            _vm._v(_vm._s(_vm.result.type))
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "h3",
        {
          staticClass: "c-resources-card__title",
          attrs: { href: _vm.result.url }
        },
        [_vm._v(_vm._s(_vm.result.title))]
      ),
      _vm._v(" "),
      _vm.result.body
        ? _c("p", { staticClass: "c-resources-card__summary" }, [
            _vm._v(_vm._s(_vm.result.body))
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "c-resources-card__actions" }, [
        _vm.result.requestedItem && _vm.showForm
          ? _c(
              "button",
              {
                staticClass: "c-button",
                class: _vm.getButtonState(_vm.result.id),
                attrs: { type: "submit" },
                on: { click: _vm.toggleItem }
              },
              [
                _vm._v(
                  _vm._s(
                    this.activeItem
                      ? _vm.getActiveButtonText()
                      : _vm.getDefaultButtonText()
                  )
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.result.button
          ? _c(
              "a",
              {
                staticClass: "c-button",
                class: _vm.result.button.asLink
                  ? "c-button--neutral"
                  : "c-button--secondary",
                attrs: { target: "_blank", href: _vm.result.button.url }
              },
              [_vm._v(_vm._s(_vm.result.button.text))]
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0fa09550", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fa09550","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/geneco/resources/card/Card.vue
// module id = 574
// module chunks = 0